import { StateSchema } from 'app/config/storeConfig/types';
import { BookingSteps } from '../types';

export const getActiveStep = (state: StateSchema): BookingSteps => state.bookingHeader.activeStep;
